import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { MenuItem, Select } from "@mui/material";
import { useUnit } from "effector-react";
import { CustomersStore } from "../../../../stores/CustomersStore/CustomersStore";
import { renderWashType } from "../../utils";
import { WashingType } from "../../../../types/washingTypes.types";

interface Props {
  washingType: WashingType;
  onChange?: (id: WashingType) => void;
}

const SelectWashType: React.FC<Props> = ({ washingType, onChange }: Props) => {
  const { washingTypes } = useUnit(CustomersStore);

  const renderOptions = () => {
    return washingTypes?.map((option) => (
      <MenuItem key={option.id} value={option.id}>
        {renderWashType(option)}
      </MenuItem>
    ));
  };

  const handleChange = (e: any) => {
    const selectedWashingId = e?.target?.value;

    const washType =
      washingTypes.find((option) => option.id === selectedWashingId) ??
      washingTypes[0];
    if (onChange) {
      onChange(washType);
    }
  };

  return (
    <Box sx={{ minWidth: 300 }}>
      <FormControl fullWidth disabled={!washingTypes?.length}>
        <InputLabel variant="outlined" htmlFor="select-washtype">
          Tipo de Lavação
        </InputLabel>
        <Select
          labelId="select-washtype"
          id="demo-simple-select"
          value={washingType?.id ?? ""}
          label="Tipo de lavação"
          onChange={handleChange}
        >
          {renderOptions()}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectWashType;
